import * as React from "react";
import { cn } from "../../lib/utils";

const Textarea = React.forwardRef(({ className, style, onFocus, onBlur, ...props }, ref) => {
  const [focused, setFocused] = React.useState(false);

  return (
    <textarea
      ref={ref}
      className={cn(
        "tw-flex tw-min-h-[96px] tw-w-full tw-rounded-xl tw-border tw-border-white/10 tw-bg-white/[0.03] tw-px-4 tw-py-3 tw-text-[14px] tw-text-white tw-transition-colors placeholder:tw-text-muted disabled:tw-cursor-not-allowed disabled:tw-opacity-50 tw-resize-none",
        className
      )}
      style={{
        minHeight: 96,
        width: "100%",
        padding: "10px 16px",
        borderRadius: 12,
        background: "rgba(255,255,255,0.035)",
        border: `1px solid ${focused ? "rgba(0,173,181,0.5)" : "rgba(255,255,255,0.12)"}`,
        boxShadow: focused
          ? "inset 0 1px 2px rgba(0,0,0,0.15), 0 0 0 3px rgba(0,173,181,0.18)"
          : "inset 0 1px 2px rgba(0,0,0,0.15)",
        outline: "none",
        color: "#fff",
        fontSize: 14,
        lineHeight: 1.5,
        resize: "none",
        fontFamily: "inherit",
        transition: "border-color 0.12s ease, box-shadow 0.12s ease",
        boxSizing: "border-box",
        ...style,
      }}
      onFocus={(e) => { setFocused(true); onFocus?.(e); }}
      onBlur={(e) => { setFocused(false); onBlur?.(e); }}
      {...props}
    />
  );
});
Textarea.displayName = "Textarea";

export { Textarea };
